import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutModule } from '../shared/layout/layout.module';
import { MatSortModule, MatTableModule } from '@angular/material';
import { StoreModule } from '@ngrx/store';
import { BrowserModule } from '@angular/platform-browser';
import { TooltipModule } from 'ng2-tooltip-directive';
import { SharedModule } from '../shared/shared.module';
import { GetNumberComponent } from './get-number.component';
import { getNumberRoutes } from './get-number.routes';
import { PricingNumbersService } from '../shared/services/pricing-numbers.service';
import { pricingNumbersReducer } from './pricing-numbers/pricing-numbers.reducer';
import { PricingNumbersEffects } from './pricing-numbers/pricing-numbers.effects';
import { PricingNumbersResolve } from './pricing-numbers/pricing-numbers.resolve';
import { PricingNumbersComponent } from './pricing-numbers/pricing-numbers.component';
import { PriceComponent } from './pricing-numbers/price/price.component';
import { DocumentsTooltipIconComponent } from './pricing-numbers/documents-tooltip-icon/documents-tooltip-icon.component';
import { PricingNumbersTableComponent } from './pricing-numbers/pricing-numbers-table/pricing-numbers-table.component';
import { GetNumberTopBarComponent } from './get-number-top-bar/get-number-top-bar.component';
import { ChooseNumberComponent } from './pricing-numbers/choose-number/choose-number.component';
import { SearchInputComponent } from './pricing-numbers/search-input/search-input.component';
import { NumbersTableComponent } from './pricing-numbers/choose-number/numbers-table/numbers-table.component';
import { NumberTypesDropdownComponent } from './pricing-numbers/number-types-dropdown/number-types-dropdown.component';
import { RegionsDropdownComponent } from './pricing-numbers/regions-dropdown/regions-dropdown.component';
import { EmptyNumbersComponent } from './pricing-numbers/choose-number/empty-numbers/empty-numbers.component';
import { FreePortingDialogComponent } from './free-porting-dialog/free-porting-dialog.component';
import { GetNumberFinalStepComponent } from './get-number-final-step/get-number-final-step.component';
import { SinglePricingResolve } from './pricing-numbers/single-pricing.resolve';
import { GetNumberOrderDetailsComponent } from './get-number-final-step/get-number-order-details/get-number-order-details.component';
import { MsisdnLabelComponent } from './get-number-final-step/msisdn-label/msisdn-label.component';
import { MyAccountModule } from '../my-account/my-account.module';
import { FirstNumberWelcomeComponent } from './first-number-welcome/first-number-welcome.component';

@NgModule({
  declarations: [
    GetNumberComponent,
    PricingNumbersComponent,
    PriceComponent,
    DocumentsTooltipIconComponent,
    PricingNumbersTableComponent,
    GetNumberTopBarComponent,
    PricingNumbersTableComponent,
    ChooseNumberComponent,
    SearchInputComponent,
    NumbersTableComponent,
    NumberTypesDropdownComponent,
    RegionsDropdownComponent,
    EmptyNumbersComponent,
    FreePortingDialogComponent,
    GetNumberFinalStepComponent,
    GetNumberOrderDetailsComponent,
    MsisdnLabelComponent,
    FirstNumberWelcomeComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule,
    LayoutModule,
    MatTableModule,
    MatSortModule,
    TooltipModule,
    RouterModule.forChild(getNumberRoutes),
    SharedModule,
    StoreModule.forFeature('pricingNumbers', pricingNumbersReducer),
    EffectsModule.forFeature([PricingNumbersEffects]),
    MyAccountModule
  ],
  providers: [PricingNumbersService, PricingNumbersResolve, SinglePricingResolve],
  exports: [GetNumberComponent, DocumentsTooltipIconComponent, FirstNumberWelcomeComponent],
  entryComponents: [PriceComponent, FreePortingDialogComponent]
})
export class GetNumberModule {}
